import React from 'react';
import PropTypes from 'prop-types';

import intlShape from '@/shared/utils/intlShape';
import messages from '../registrationMessages';
import FormGroupPart from './FormGroupPart';
import DurationDaysInfoPart from './DurationDaysInfoPart';

const HalfDayFormGroup = ({ isAfternoon, duration, userId, date, resourceType, onChange, intl, disabled }) => {
  const handleChange = e => onChange(parseInt(e.target.value) > 0);

  return (
    <div className="form-group">
      <FormGroupPart inputCols="col-sm-6">
        <label className="radio-inline">
          <input
            name="isAfternoon"
            onChange={handleChange}
            disabled={disabled}
            value="0"
            checked={!isAfternoon}
            type="radio"
          />
          {intl.formatMessage(messages.Morning)}
        </label>
        <label className="radio-inline">
          <input
            name="isAfternoon"
            onChange={handleChange}
            disabled={disabled}
            value="1"
            checked={!!isAfternoon}
            type="radio"
          />
          {intl.formatMessage(messages.Afternoon)}
        </label>
      </FormGroupPart>
      <div className="col-sm-4">
        <DurationDaysInfoPart {...{ duration, userId, date, isAfternoon, resourceType, intl }} />
      </div>
    </div>
  );
};

HalfDayFormGroup.propTypes = {
  isAfternoon: PropTypes.bool,
  resourceType: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
};
HalfDayFormGroup.defaultProps = {
  isAfternoon: false,
  resourceType: null,
  disabled: false,
};
export default HalfDayFormGroup;
